<app-top-bar></app-top-bar>

<router-outlet></router-outlet>